import { Component } from '@angular/core';
import { DetectorLearningConfig } from '../node-lifecycle.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-node-lifecycle-detector-modal',
  templateUrl: './node-lifecycle-detector-modal.component.html',
  styleUrl: './node-lifecycle-detector-modal.component.scss'
})
export class NodeLifecycleDetectorModalComponent {
  public selectedConfiguration: DetectorLearningConfig | undefined

  constructor(
    public dialogRef: MatDialogRef<NodeLifecycleDetectorModalComponent>
  ) {
    this.selectedConfiguration = {
      timeLimitHours: undefined,
      uclVariationPercentage: undefined
    }
  }

  execute(): void {
    if(this.selectedConfiguration?.uclVariationPercentage){
      this.selectedConfiguration.uclVariationPercentage /= 100
    }
    this.dialogRef.close(this.selectedConfiguration)
  }
}
